import {
  BlockContentValue,
  Button,
  Icon
} from "@silversea-ssc/ui-components-react";
import clsx from "clsx";
import { BlockContent } from "components/BlockContent";
import DateOnlyFormat from "components/DateOnlyFormat";
import React, { PropsWithChildren } from "react";
import { formatArrivalDepartureTime } from "../Utils";
import * as styles from "./CruiseItineraryItem.module.scss";

type ItineraryItemExpandProps = {
  opened: boolean;
  className?: string;
};

export const ItineraryItemExpand: React.FC<ItineraryItemExpandProps> = ({
  opened,
  className
}) => {
  return (
    <div className={clsx(styles.expand, className)}>
      <Button
        renderAs="div"
        variant="text"
        iconName={opened ? "chevron-up" : "chevron-down"}
        dataContentPiece={opened ? "close" : "open"}
        //onClick={() => toggleDetails}
      />
    </div>
  );
};

type ItineraryItemDateProps = {
  date?: Date | string;
  isOvernight?: boolean;
  arrivalTime?: string;
  departureTime?: string;
  containerClassName?: string;
  dateClassName?: string;
};

export const ItineraryItemDate: React.FC<ItineraryItemDateProps> = ({
  containerClassName,
  dateClassName,
  date,
  isOvernight = false,
  arrivalTime,
  departureTime
}) => {
  return (
    <div className={clsx(styles.dateContainer, containerClassName)}>
      {isOvernight && (
        <Icon
          size="1.5x"
          className={styles.overnightIcon}
          padding="inline"
          name="evening-excursions"
        />
      )}
      <div className={dateClassName}>
        <DateOnlyFormat
          value={date}
          format={{
            month: "long",
            day: "numeric",
            weekday: "short"
          }}
        />{" "}
        <div>{formatArrivalDepartureTime(arrivalTime, departureTime)}</div>
      </div>
    </div>
  );
};

type ItineraryItemTitleProps = {
  title?: string | BlockContentValue;
  className?: string;
  worldLocation?: string;
  portType?: "day-at-sea" | "port";
};

export const ItineraryItemTitle: React.FC<
  PropsWithChildren<ItineraryItemTitleProps>
> = ({ title, className, worldLocation, portType, children }) => {
  const isDayAtSea = portType === "day-at-sea";
  return (
    <React.Fragment>
      <div className={clsx(styles.title, className)}>
        <BlockContent value={title} />
        {!isDayAtSea && worldLocation && (
          <React.Fragment>, {worldLocation}</React.Fragment>
        )}
      </div>
      {isDayAtSea && (
        <div className={styles.stopWorldLocation}>{worldLocation}</div>
      )}
      {children && <div className={styles.excursions}>{children}</div>}
    </React.Fragment>
  );
};
